import React, { useState } from 'react';
import ReactPaginate from 'react-paginate';
import { CardText, Input, PaginationItem, PaginationLink, Row, Col } from 'reactstrap';
import pdf from "@src/assets/images/pdf.png";

const DocumentList = ({ documents, onToggleDocument, onCheckChange }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const ITEMS_PER_PAGE = 10;
  const totalPages = Math.ceil(documents.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  const paginatedDocuments = documents.slice(startIndex, endIndex);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage + 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const Previous = () => {
    return (
      <span className='align-middle d-none d-md-inline-block'>Anterior</span>
    );
  };

  const Next = () => {
    return (
      <span className='align-middle d-none d-md-inline-block'>Siguiente</span>
    );
  };

  return (
    <>
      {paginatedDocuments.map((document, index) => (
        <tr key={index}>
          <td
            className={"text-center"}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CardText className="form-check form-check-inline text-center cursor-pointer">
              <Input
                className={"cursor-pointer"}
                type="checkbox"
                defaultChecked={false}
                onChange={(e) => {
                  onCheckChange(e.target.checked, document);
                }}
              />
            </CardText>
          </td>
          <td className={"cursor-pointer"}>
            <div
              style={{ display: "flex" }}
              className={
                "cursor-pointer text-capitalize"
              }
              onClick={() => {
                onToggleDocument(index, document);
              }}
            >
              <img
                className="me-75"
                src={pdf}
                alt={document.name}
                height="20"
                width="20"
              />
              {document.name?.toString().replaceAll(".pdf", "")}
            </div>
          </td>
        </tr>
      ))}

      {totalPages > 1 && (
        <tr>
          <td colSpan={2} className="text-center">
            <Row>
              <Col md={{ size: 6, offset: 3 }}>
                <ReactPaginate
                  previousLabel={<Previous />}
                  nextLabel={<Next />}
                  forcePage={currentPage - 1}
                  onPageChange={({ selected }) => handlePageChange(selected)}
                  pageCount={totalPages}
                  breakLabel={'...'}
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={2}
                  activeClassName={'active'}
                  pageClassName={'page-item'}
                  nextLinkClassName={'page-link'}
                  nextClassName={'page-item next'}
                  previousClassName={'page-item prev'}
                  previousLinkClassName={'page-link'}
                  pageLinkClassName={'page-link'}
                  breakClassName='page-item'
                  breakLinkClassName='page-link'
                  containerClassName={'pagination react-paginate pagination-sm justify-content-center mt-2'}
                />
              </Col>
            </Row>
          </td>
        </tr>
      )}
    </>
  );
};

export default DocumentList;
